import { render } from "./AppEventSection.vue?vue&type=template&id=8998d810"
import script from "./AppEventSection.vue?vue&type=script&lang=js"
export * from "./AppEventSection.vue?vue&type=script&lang=js"

import exportComponent from "/home/vsts/work/1/s/majstro/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__